﻿import { createFocusTrap } from 'focus-trap';
import { accessibleSelect } from './select';

export const createConfirm = (heading, message, settings = { close: 'Close', cancel: 'Cancel', confirm: 'Confirm' }, onConfirmEvent) => {
  //return new Promise((resolve) => {
  const html = document.querySelector('html');
  const wrapper = document.createElement('DIV');
  let select = '';
  let checkbox = '';
  if (settings.checkbox) {
    checkbox = `<div class="myaimopark-confirm__checkbox-wrapper">
    <label class="myaimopark-confirm__checkbox">
    <input class="myaimopark-confirm__checkbox-original" type="checkbox">
    <span class="myaimopark-confirm__checkbox-check"></span>
    <span class="myaimopark-confirm__checkbox-label"><span>${settings.label}</span>
    </span></span></label></div>`
  }
  if (settings.options) {
    let selectOptions = `<option selected="true" disabled="true" value="">${settings.initialOption}</option>`;
    for (const [key, value] of Object.entries(settings.options)) {
      selectOptions = selectOptions + `<option value="${key}">${value}</option>`
    }
    select = `<div class="myaimopark-confirm__select-wrapper">
					<label>${settings.label}</label>
					<select name="terminate" data-controller="accessible-select">
						${selectOptions}						
					</select>
				</div>`
  }
  wrapper.classList.add('myaimopark-confirm');
  wrapper.setAttribute('data-selection-no', 'true');
  wrapper.innerHTML =
    `<section class="myaimopark-confirm__box" role="alert">
      <header>
        <button data-selection-no="true">${settings.close}</button>
      </header>
      <main>
        <h1>${heading}</h1>
        ${message ? '<p>' + message + '</p>' : ''}
        ${select}       
        ${checkbox}       
        ${settings.cancel ? '<button data-selection-no="true" class="myaimopark-confirm__box__cancel">' + settings.cancel + '</button>' : ''}
        ${!settings.hideConfirm ? `<button data-selection-yes="true" ${settings.dataButton ? settings.dataButton.includes('admin') || settings.dataButton.includes('customer') ? `data-pp-button=${settings.dataButton}` : `data-map-button=${settings.dataButton}` : ''} class="myaimopark-confirm__box__confirm" ${select || checkbox ? 'disabled' : ''}>${settings.confirm}</button>` : ''}
      </main>
    </section>`;

  wrapper.addEventListener('click', async function (e) {
    if (wrapper.hasAttribute('aria-busy'))
      return;

    if (e.target.dataset && (e.target.dataset.selectionYes || e.target.dataset.selectionNo)) {
      const confirmStatus = (e.target.dataset.selectionYes !== null && e.target.dataset.selectionYes !== undefined);

      if (confirmStatus && onConfirmEvent !== null) {
        wrapper.setAttribute('aria-busy', 'true');
        trap.pause();

        const confirmEventResponse = await onConfirmEvent();
        if (!confirmEventResponse) {
          wrapper.removeAttribute('aria-busy');
          trap.unpause();
        }
      }

      //resolve(confirmStatus);
      trap.deactivate();
    }
  });

  html.appendChild(wrapper);
  html.classList.add('map-confirm-overlay-active');

  if (settings.zIndex) wrapper.style.zIndex = settings.zIndex;
  if (settings.options) {
    const confirmSelect = wrapper.querySelector('select');
    const confirmButton = wrapper.querySelector('.myaimopark-confirm__box__confirm');
    wrapper.querySelector('main p').style.paddingBottom = '2rem';
    accessibleSelect(confirmSelect);

    confirmSelect.addEventListener('change', function (e) {
      if (e.target.value) confirmButton.removeAttribute('disabled');
      else confirmButton.setAttribute('disabled', 'true');
    });
  }

  const trap = createFocusTrap(wrapper, {
    onDeactivate: () => {
      //resolve(false);

      html.removeChild(wrapper);
      html.classList.remove('map-confirm-overlay-active');
    }
  });

  trap.activate();
  //});
}
